import React from 'react';

export const Blank: React.FC = () => {
  return <div />;
};
